import { AfterViewInit, Component, ComponentFactoryResolver, EventEmitter, Injector, OnInit, TemplateRef, Type, ViewChild, ViewContainerRef } from '@angular/core';
import { VDialogRef } from "./v-dialog-ref";
import './v-dialog.component.scss';
import { DialogContentType, DialogService } from "./v-dialog.service";

@Component({
    selector: 'v-dialog',
    template: require('./v-dialog.component.html')
})
export class VDialogComponent implements OnInit, AfterViewInit {
    contentType: DialogContentType;
    content: string | TemplateRef<any> | Type<any>;
    context;
    attachedComponent: Type<any>;

    @ViewChild("modalContent", { read: ViewContainerRef }) modalContent: ViewContainerRef;

    constructor(private ref: VDialogRef, private injector: Injector,
        private componentFactoryResolver: ComponentFactoryResolver) { }

    close(): void {
        this.ref.close(null);
    }

    ngOnInit(): void {
        this.content = this.ref.content;

        var dialogService = this.injector.get(DialogService, null);
        this.contentType = dialogService.getContentType(this.content);

        if (this.contentType == "template") {
            this.context = {
                close: this.ref.close.bind(this.ref)
            };
        }
    }

    ngAfterViewInit(): void {
        if (this.contentType == "component") {
            this.createComponent();
        }
    }

    createComponent() {
        if (!this.modalContent) {
            return this.modalContent;
        }

        const viewContainerRef = this.modalContent;
        viewContainerRef.clear();

        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.content as Type<any>);
        const componentRef = viewContainerRef.createComponent(componentFactory);

        // Set bindings
        Object.keys(this.ref.data).forEach(key => {
            componentRef.instance[key] = this.ref.data[key];
        })

        // Dynamically bind Outputs
        Object.entries(this.ref.outputs).forEach(([outputName, callback]) => {
            if (componentRef.instance[outputName] instanceof EventEmitter) {
                componentRef.instance[outputName].subscribe(callback);
            }
            else {
                console.warn(`Output ${outputName} is not an EventEmitter on the component.`);
            }
        });

        componentRef.changeDetectorRef.detectChanges();
        componentRef.instance?.ngOnChanges?.();
    }
}
